<button
  (click)="saveStatusClick($event)"
  class="d-flex dropdown-item align-items-center w-100 p-2"
  [value]="status()"
>
  <cfp-icon class="me-2" icon="circle" [iconStyle]="iconStyle()" [iconType]="'solid'" />
  <span [class.fw-bold]="selectedStatus() === status()" class="me-2">{{
    `filter.measureStatus.${status()}` | translate
  }}</span>
  @if (selectedStatus() === status()) {
    <cfp-icon class="ms-auto" icon="check" [iconStyle]="'dark'" [iconType]="'solid'" />
  }
</button>
